import { useTransition } from 'react';
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';
import { useDigitalContext } from '../../context/digital';

export const useCustomQuery = <T = unknown, E = unknown>({
  queryKey,
  enabled,
  queryFn,
  refetchInterval,
  options = {},
}: {
  queryKey: QueryKey;
  enabled?: boolean;
  refetchInterval?: number;
  queryFn: () => Promise<T> | T;
  options?: UseQueryOptions<T, E>;
}) => {
  const { dispatch } = useDigitalContext();
  const [_, startTransition] = useTransition();

  return useQuery<T, E>({
    queryKey,
    queryFn,
    enabled,
    refetchInterval,
    onSuccess: (data: T) => {
      (options.onSuccess as ((data?: T) => void) | undefined)?.(data);
    },
    onError: (error: any) => {
      if (error.response.data.error_id === 'non_working_time') {
        startTransition(() => {
          dispatch({ type: 'NON_WORKING_HOUR', payload: true });
        });

        return;
      }

      (options.onError as ((error?: E) => void) | undefined)?.(error);
    },
  });
};
